import { Typography } from '@material-ui/core'
import React from 'react'
import './SignUp.css'
import { useSelector, useDispatch } from 'react-redux'
import { setEmail, setPhoneNumber } from 'redux/actions/'
import { validatePhoneNumber } from 'utils/validatePhoneNumber'

export default function Login() {
  const dispatch = useDispatch()
  const { email, phoneNumber } = useSelector(state => state.signup)

  const handlePhoneNumber = e => {
    const value = e.target.value
    const { validPhone } = validatePhoneNumber(value)
    dispatch(setPhoneNumber(validPhone))
  }
  return (
    <>
      <Typography variant="h2" align="center" style={{ padding: '25px 0' }}>
        What is your contact details?
      </Typography>
      <div>
        <label>Email Address</label>
        <input
          placeholder="example@domain.com"
          type="text"
          value={email}
          onChange={e => dispatch(setEmail(e.target.value))}
        />
        <label>Phone Number</label>
        <input
          placeholder="+964 77* 000 00 00"
          type="text"
          value={phoneNumber}
          onChange={handlePhoneNumber}
        />
      </div>
    </>
  )
}
